class Tooltip {
  element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;

    this.init();
  }

  init() {
    const tooltip = document.createElement("div");
    tooltip.innerHTML = this.element.innerHTML;
    tooltip.classList.add("js-tooltip");
    tooltip.classList.add("tooltip__content");

    const tooltipTrigger = document.createElement("button");
    tooltipTrigger.innerHTML = "?";
    tooltipTrigger.classList.add("js-tooltip-toggle");
    tooltipTrigger.classList.add("tooltip__button");

    this.element.innerHTML = "";
    this.element.append(tooltipTrigger);
    this.element.append(tooltip);
  }
}

export default Tooltip;
